module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABTElEQVRIib2WO0sDQRDHf4mPRLFJrb1EiCCICPohrK0tLOwiaGdnI2lsFAU/hB/AwloCgs9CFASxUBFCxGcMI7MQwt7Dzd7+4bjb2Zn7zd7dzG2ueTKHg8aBVeAdqAF3Sbfod4CUgEsgp+MlYBR4iQvKO4CWOyCiIrCeFOQCKltsM1mABi22kSxAtq+n6Bs0DYxZ7J++QQcR9oZP0C5QiZg7TApOU0ezwBYwH+OzoI+1BfzqIXrSBK+lM0wCVWBIHT6ADeAWqANTKZKJ0w8wIStaAxa7HB+0CHuFiPqAFXlHb5bJlp5tcy4qCejbEvjlCWB041KwLroKBToNAXqU30oI0DmOTfW/Og4FOgsFqocA3ZuNS9agC3ORj+jgA55AR50g6drdMm1+uAdIE9gzA1nNpu7JCmqTRrqjW6pttRtwGknyz8A+8PoXALQBJ0Y41faH5lcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mine/tuijian.png
// module id = 7Ir1
// module chunks = 1